const MetaTags = ({ pageProps, router }) => {
  const tags = [];

  // Default values
  const defaultTitle = 'StreamAlive - Interactive Audience Engagement Platform';
  const defaultDescription = 'StreamAlive is the ultimate interactive audience engagement platform for live presentations, webinars, and events. Create polls, Q&As, word clouds and more to boost audience participation.';
  const defaultImage = `${process.env.NEXT_PUBLIC_APP_URL || 'https://app.streamalive.com'}/images/streamalive-og-image.png`;

  if (!pageProps || !pageProps.pageMetaData) {
    // Default meta tags when no page-specific data is provided
    tags.push(
      <title key="title">{defaultTitle}</title>,
      <meta key="description" name="description" content={defaultDescription} />,

      // Open Graph meta tags
      <meta key="og-type" property="og:type" content="website" />,
      <meta key="og-title" property="og:title" content={defaultTitle} />,
      <meta key="og-description" property="og:description" content={defaultDescription} />,
      <meta key="og-image" property="og:image" content={defaultImage} />,
      <meta key="og-image-width" property="og:image:width" content="1200" />,
      <meta key="og-image-height" property="og:image:height" content="630" />,
      <meta key="og-site-name" property="og:site_name" content="StreamAlive" />,

      // Iframely meta tags for rich previews
      <link
        key="iframely-link"
        rel="iframely"
        href={router.asPath ? `${process.env.NEXT_PUBLIC_APP_URL}${router.asPath}` : process.env.NEXT_PUBLIC_APP_URL}
        type="text/html"
        media="(aspect-ratio: 1280/720)"
      />,
      <meta key="iframely-title" property="iframely:title" content={defaultTitle} />,
      <meta key="iframely-description" property="iframely:description" content={defaultDescription} />,
      <meta key="iframely-image" property="iframely:image" content={defaultImage} />,

      // oEmbed discovery — tells iFramely and embedding platforms where to find the rich-embed endpoint
      <link
        key="oembed-json"
        rel="alternate"
        type="application/json+oembed"
        href={`${process.env.NEXT_PUBLIC_API_URL}oembed?url=${encodeURIComponent(router.asPath ? `${process.env.NEXT_PUBLIC_APP_URL}${router.asPath}` : process.env.NEXT_PUBLIC_APP_URL)}`}
        title="StreamAlive Interactive Widget"
      />
    );
  } else {
    const { title, description, image, imageWidth, imageHeight, url } = pageProps.pageMetaData;
    const finalTitle = title || defaultTitle;
    const finalDescription = description || defaultDescription;
    const finalImage = `${process.env.NEXT_PUBLIC_APP_URL}${image || defaultImage}`;
    const finalUrl = `${process.env.NEXT_PUBLIC_APP_URL}${url}`;

    tags.push(<title key="title">{finalTitle}</title>);
    tags.push(<meta key="description" name="description" content={finalDescription} />);

    // Open Graph meta tags
    tags.push(<meta key="og-type" property="og:type" content="website" />);
    tags.push(<meta key="og-title" property="og:title" content={finalTitle} />);
    tags.push(<meta key="og-description" property="og:description" content={finalDescription} />);
    tags.push(<meta key="og-image" property="og:image" content={finalImage} />);
    tags.push(<meta key="og-image-width" property="og:image:width" content={imageWidth || '482'} />);
    tags.push(<meta key="og-image-height" property="og:image:height" content={imageHeight || '250'} />);
    tags.push(<meta key="og-site-name" property="og:site_name" content="StreamAlive" />);

    if (finalUrl) {
      tags.push(<meta key="og-url" property="og:url" content={finalUrl} />);
    }

    // Iframely meta tags for rich previews
    tags.push(<meta key="iframely-title" property="iframely:title" content={finalTitle} />);
    tags.push(<meta key="iframely-description" property="iframely:description" content={finalDescription} />);
    tags.push(<meta key="iframely-image" property="iframely:image" content={finalImage} />);
    tags.push(<link key="iframely-link" rel="iframely" href={finalUrl} media="(aspect-ratio: 1280/720)" />);

    // oEmbed discovery — tells iFramely and embedding platforms where to find the rich-embed endpoint
    tags.push(
      <link
        key="oembed-json"
        rel="alternate"
        type="application/json+oembed"
        href={`${process.env.NEXT_PUBLIC_API_URL}oembed?url=${encodeURIComponent(finalUrl)}`}
        title="StreamAlive Interactive Widget"
      />
    );
  }

  return <>{tags}</>;
};

export default MetaTags;
